import { render, staticRenderFns } from "./RulesetViewer.vue?vue&type=template&id=35ade3d9&scoped=true&"
import script from "./RulesetViewer.vue?vue&type=script&lang=js&"
export * from "./RulesetViewer.vue?vue&type=script&lang=js&"
import style0 from "./RulesetViewer.vue?vue&type=style&index=0&id=35ade3d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ade3d9",
  null
  
)

export default component.exports